

import { ReactColorPicker } from "./styled"

import { Label } from '../styled'

export default function ColorPicker ({ label, name, coolFormat, showTime, minDate, maxDate, formik  }) {
    return (
        <div style={{ marginBottom: "16px", width: "100%" }}>
            <Label>
                <label htmlFor={name}>{label}</label>

                <div>
                    {formik.touched[name] && formik.errors[name] ? formik.errors[name] : null}
                </div>
            </Label>

            <ReactColorPicker 
                name={name} 
                color={formik.values[name]} 
                onChange={color => formik.setFieldValue(name, color.hex)}
            />
        </div>
    )
}